import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';


const Container = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 0px;
  background-color: #E7E6E6;
  height: 16px;
`;

const Gauge = styled.div`
  position: absolute;
  top: 0;
  right: ${props => props.fillPercentage}%;
  left: 0;
  bottom: 0;
  background-color: ${props => props.color};
`;

const TextWrapper = styled.div`
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

class Gauges extends React.Component {

  static propTypes = {
    currentValue: PropTypes.number,
    maxValue: PropTypes.number,
    text: PropTypes.string,
    color: PropTypes.string
  }

  render = () => {

    const fillPercentage = Math.min(Math.round((this.props.currentValue / this.props.maxValue) * 100), 100);
    return (
      <Container>
        <Gauge color={this.props.color} fillPercentage={100 - fillPercentage}></Gauge>
        <TextWrapper>{this.props.text}</TextWrapper>
      </Container>
    );
  }
}

export default Gauges;
